import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React from 'react';
import { Pressable as RNPressable } from 'react-native';
import EditIcon from 'src/components/10-atoms/icons/EditIcon';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import SortableItemIcon from 'src/components/10-atoms/icons/SortableItemIcon';
import Column from 'src/components/10-atoms/layout/Column';
import Row from 'src/components/10-atoms/layout/Row';
import CircularProgressBar from 'src/components/10-atoms/progress-bar/CircularProgressBar';
import Typography from 'src/components/10-atoms/typography/Typography';
import { PRESSABLE_SIZE } from 'src/components/templates/PressableArea';
import { TypographyVariant } from 'src/customizations/themes/10-parts/typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import withPress from 'src/hoc/withPress';
import { getSubjectAnswerCompletion } from 'src/modules/exam-preparation/graphql/subject/utils';
const SubjectItemView = ({ subject, isEditMode = false, onEdit, dragHandle, style, ...rowProps }) => {
    const [{ styles, theme }] = useTheme(stylesGenerator);
    const answerCompletion = getSubjectAnswerCompletion(subject);
    return (React.createElement(Row, { xAxis: "space-between", yAxis: "center", spacing: 24, bg: theme.palette.background.dark, style: [styles.container, style], ...rowProps },
        dragHandle,
        React.createElement(Column, { yAxis: "center", flex: true },
            React.createElement(Typography, { numberOfLines: 3, ellipsizeMode: "tail" }, subject.data.title),
            !!subject.data.description && (React.createElement(Typography, { flex: true, numberOfLines: 3, ellipsizeMode: "tail", variant: TypographyVariant.CAPTION, color: theme.palette.typography.secondary }, subject.data.description))),
        React.createElement(Row, { yAxis: "center", spacing: theme.spacing.standard.xxs }, isEditMode ? (React.createElement(RNPressable, { onPress: e => {
                e?.stopPropagation?.();
                onEdit?.(subject);
            }, hitSlop: 8 },
            React.createElement(EditIcon, { size: theme.iconSize.sm, color: theme.palette.primary.main }))) : (React.createElement(React.Fragment, null,
            React.createElement(CircularProgressBar, { size: theme.iconSize.lg, value: answerCompletion }),
            React.createElement(FeatherIcon, { name: "chevron-right", color: theme.palette.primary.main }))))));
};
const PressableSubjectItem = withPress(SubjectItemView);
const SortableSubjectItem = props => {
    const [{ theme }] = useTheme(stylesGenerator);
    const { attributes, listeners, setNodeRef, transform, transition, isDragging, } = useSortable({ id: props.subject.id });
    const sortableStyle = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        zIndex: isDragging ? 1 : 0,
        position: 'relative',
    };
    return (React.createElement("div", { ref: setNodeRef, style: sortableStyle },
        React.createElement(SubjectItemView, { ...props, isEditMode: true, dragHandle: (React.createElement("div", { ...attributes, ...listeners, style: {
                    cursor: 'grab',
                    touchAction: 'none',
                    display: 'flex',
                    alignItems: 'center',
                } },
                React.createElement(SortableItemIcon, { size: theme.iconSize.sm, color: theme.palette.icon.secondary }))) })));
};
const SubjectItem = props => {
    if (props.isEditMode) {
        return React.createElement(SortableSubjectItem, { ...props });
    }
    return React.createElement(PressableSubjectItem, { ...props });
};
const stylesGenerator = createThemedStyle(({ theme }) => ({
    container: {
        minHeight: PRESSABLE_SIZE,
    },
}));
export default SubjectItem;
